var Messages = function () {

  this.DisplayFormats = {
    Session: {
      sessionDate: 'DD MMM YYYY',
      readingRate: 'wpm',
      duration: 's',
      percent: '%'
    }
  };


  Object.defineProperties(this, {
    'Message': {
      get: () => ({
        Account: {
          passwordTooltip: i18n.t('Password must be at least: 6 characters, one digit (\'0\' - \'9\'), one lowercase (\'a\'-\'z\').', {
            context: 'tooltip',
            ns: 'main'
          }),
          emailTooltip: i18n.t('Your Email will be used as Username to login to the system.', {
            context: 'tooltip',
            ns: 'main'
          })
        }
      })
    },
    'Error': {
      get: () => ({
        DEFAULT_ERROR: '',

        PROFILE_UPDATE_ACCOUNT_FAILURE: {
          userEmailValidation: i18n.t("Email is already used as Username for some other User. Please enter another Email.", {
            context: 'serverError',
            ns: 'main'
          }),
          passwordValidation: i18n.t("Password is incorrect. Please, create password according to the rules.", {
            context: 'serverError',
            ns: 'main'
          })
        },

        USERS_UPDATE_USER_FAILURE: {
          userEmailValidation: i18n.t("Email is already used as Username for some other User. Please enter another Email.", {
            context: 'serverError',
            ns: 'main'
          }),
          passwordValidation: i18n.t("Password is incorrect. Please, create password according to the rules.", {
            context: 'serverError',
            ns: 'main'
          })
        },

        ACCOUNT_ACTIVATE_FAILURE: {
          getAccountValidationError: (orgName) => i18n.t("Your activation link has expired. To get new link please contact {{orgName}}.", {
            orgName,
            context: 'serverError',
            ns: 'main'
          })
        },

        ACCOUNT_RESET_PASSWORD_FAILURE: {
          resetPasswordValidation: i18n.t("Your reset password link has expired. To get new link please contact 2Eskimos Team.", {
            context: 'serverError',
            ns: 'main'
          })
        },

      })
    }
  })

};

module.exports = new Messages();
